import { Component } from '@angular/core';

@Component({
    selector: 'job-postings-help',
    templateUrl: './job-postings-help.component.html',
    standalone: false
})
export class JobPostingsHelpComponent{}

